import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class UtilsService {

  constructor() { }

  extractValueFromObject(obj: any, path: string): any {
    let reg = /\[\d*\]/g;
    const properties = path.split('.');
    let current = obj;
    let count = 0;
    properties.forEach((prop: string) => {
      let isArray = reg.test(prop);
      let arrayValue = isArray ? prop.match(reg) : undefined;
      prop = isArray ? prop.replace(reg, '') : prop;
      if (current && current[prop]) {
        if (isArray && arrayValue) {
          let arrayIndex = arrayValue[0].replace('[', '').replace(']', '')
          current = current[prop][arrayIndex[0]];
        } else {
          current = current[prop];
        }
        count++;
      }
    });
    return count === properties.length ? current : null;
  }
}
